/* ── THE CUSTOMER-FACING RUG NAME, FOR CARDS BUILT IN THE BROWSER ───────────
 * window.RugName.from(title, type) -> "Willow Blue Traditional Washable Rug"
 *
 * THIS IS THE SECOND EXPRESSION OF ONE RULE, NOT A SECOND RULE.
 * `snippets/rug-short-name.liquid` is the definition and carries the reasoning;
 * this file exists for the two surfaces that have no Liquid product object to
 * render from — the rug finder, which builds its cards from an index, and the
 * favourites page, which builds them from a list in localStorage. Both read the
 * SAME two inputs the snippet does, `title` and `type`, so the two cannot
 * disagree about anything except by one of them being edited alone.
 *
 * `src/9_marketplace/test_short_name.py` is what stops that: it parses both
 * files, asserts the two vocabularies are identical strings, and replays every
 * live product title through both implementations. That is the arrangement
 * `match.py` and `fit-engine.js` already use, held by `test_conformance`.
 *
 * IT NEVER TOUCHES `product.title`. The long SEO string is what every channel
 * reads and what the page's own `<title>` and meta description are built from.
 * This is what a customer reads and nothing else.
 *
 * DO NOT ADD A THIRD COPY, and do not inline a shortening in a card builder. */
(function () {
  'use strict';

  /* BOTH LISTS ARE ORDERED MOST SPECIFIC FIRST, and that is load-bearing: the
   * phrases nest, so checking the generic form first resolves "Mid-Century
   * Modern" to "Modern" and "Sage Green" to "Green". They are byte-identical
   * to the two `split: ','` strings in the snippet and a test asserts it. */
  var STYLE = 'Mid-Century,Transitional,Scandinavian,Traditional,Farmhouse,Industrial,Coastal,Tropical,Rustic,Seasonal,Retro,Boho,Glam,Modern'.split(',');
  var COLOUR = 'Multicolour,Multicolor,Terracotta,Burgundy,Charcoal,Oxblood,Mustard,Copper,Bronze,Golden,Blush,Camel,Cream,Beige,Taupe,Ivory,Denim,Olive,Linen,Slate,Ochre,Sage,Navy,Teal,Rust,Gold,Grey,Gray,Blue,Green,Black,Brown,White,Pink,Rose,Red,Tan'.split(',');

  window.RugName = {
    from: function (title, type) {
      /* NO TITLE, NO NAME — and the caller renders whatever it rendered before
       * rather than an empty heading. A card with no name is worse than a card
       * with a long one. */
      if (!title) return '';
      var words = String(title).split(' ');
      var name = words[0] || '';
      var style = '', colour = '';
      /* WORD BY WORD, NEVER A SUBSTRING TEST: "Tan" is inside "Rectangle" and
       * "Red" is inside "Distressed". */
      for (var i = 0; i < words.length; i++) {
        var w = words[i].replace(/,/g, '').trim();
        if (!style && STYLE.indexOf(w) > -1) style = w;
        if (!colour && COLOUR.indexOf(w) > -1) colour = w;
      }
      /* THE TYPE, NEVER A WORD IN THE TITLE, so the washable claim is
       * structurally unable to land on a rug we did not print.
       *
       * AND A PRODUCT THAT IS NOT A RUG KEEPS ITS OWN TITLE (2026-09-08). The
       * `else` used to answer "Machine Made Rug" for every type that was not
       * 'Digital Print Rug', which was safe only while the shop sold rugs and
       * nothing else. It now also sells five gifts, and unguarded that branch
       * renders "Turkish Towel" as "Turkish Washable Rug" — the washable claim
       * landing on a towel. It abstains for anything that is not one of the two
       * rug types rather than for gifts specifically, so it is already correct
       * for the next non-rug product. The snippet does the same and a test
       * asserts the two agree. */
      var kind = type === 'Digital Print Rug' ? 'Washable Rug'
               : type === 'Machine Woven Rug' ? 'Machine Made Rug' : '';
      if (!kind) return String(title);
      /* EACH OPTIONAL PART BRINGS ITS OWN LEADING SPACE, so a missing colour or
       * style closes up instead of leaving a hole. */
      var out = name;
      if (colour) out += ' ' + colour;
      if (style) out += ' ' + style;
      return out + ' ' + kind;
    }
  };
})();
